import React, { useState, useEffect } from 'react';
import { Rocket, Menu, X } from 'lucide-react';
import Logo from '../assets/logo/logo.png';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0B0F1A]/80 backdrop-blur-xl border-b border-white/10' : 'bg-transparent'
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
        <div className="flex items-center justify-between">
        <button 
  onClick={() => scrollToSection('hero')} 
  className="flex items-center space-x-2 hover:opacity-80 transition-opacity"
  data-testid="nav-logo"
>
  <img 
    src={Logo} 
    alt="Jupiter Cosmic Logo"
    className="w-24 h-24 object-contain"
  />
  <span className="text-lg sm:text-xl font-bold">Jupiter Cosmic</span>
</button>
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
            <button onClick={() => scrollToSection('about')} className="hover:text-[#00E5FF] transition-colors text-sm lg:text-base" data-testid="nav-about">About</button>
            <button onClick={() => scrollToSection('services')} className="hover:text-[#00E5FF] transition-colors text-sm lg:text-base" data-testid="nav-services">Services</button>
            <button onClick={() => scrollToSection('portfolio')} className="hover:text-[#00E5FF] transition-colors text-sm lg:text-base" data-testid="nav-portfolio">Portfolio</button>
            <button onClick={() => scrollToSection('tech')} className="hover:text-[#00E5FF] transition-colors text-sm lg:text-base" data-testid="nav-tech">Tech Stack</button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="px-4 lg:px-6 py-2 rounded-full bg-gradient-to-r from-[#00E5FF] to-[#0088CC] text-[#0B0F1A] font-semibold hover:scale-105 transition-transform text-sm lg:text-base"
              data-testid="nav-contact"
            >
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 hover:bg-white/10 rounded-lg transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3" data-testid="mobile-menu">
            <button onClick={() => scrollToSection('about')} className="block w-full text-left py-2 px-4 hover:bg-white/10 rounded-lg transition-colors">About</button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left py-2 px-4 hover:bg-white/10 rounded-lg transition-colors">Services</button>
            <button onClick={() => scrollToSection('portfolio')} className="block w-full text-left py-2 px-4 hover:bg-white/10 rounded-lg transition-colors">Portfolio</button>
            <button onClick={() => scrollToSection('tech')} className="block w-full text-left py-2 px-4 hover:bg-white/10 rounded-lg transition-colors">Tech Stack</button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="block w-full text-center py-2 px-4 rounded-full bg-gradient-to-r from-[#00E5FF] to-[#0088CC] text-[#0B0F1A] font-semibold"
            >
              Contact
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
